import { createSlice } from '@reduxjs/toolkit'
import Utilisateur from 'entity/Utilisateur'
import FenetresAide from 'enums/FenetresAide'

export enum Status {
  // Generic
  Idle,
  Pending,
  Succeeded,
  Failed,
}

export interface UtilisateurState {
  utilisateur: Utilisateur | null
  errorMsg: string | null
  status: Status
}

const initialState: UtilisateurState = {
  utilisateur: null,
  errorMsg: null,
  status: Status.Idle,
}

const name = 'utilisateur'

const utilisateurSlice = createSlice({
  name,
  initialState,
  reducers: {
    // Redux Toolkit allows us to write "mutating" logic in reducers. It
    // doesn't actually mutate the state because it uses the Immer library,
    // which detects changes to a "draft state" and produces a brand new
    // immutable state based off those changes
    succeeded: (state, action) => {
      const utilisateur = action.payload

      state.utilisateur = utilisateur
      state.status = Status.Succeeded
      state.errorMsg = null
    },
    loading: (state) => {
      state.status = Status.Pending
      state.utilisateur = null
      state.errorMsg = null
    },
    error: (state, action) => {
      const eerrorMsgrr = action.payload
      state.errorMsg = eerrorMsgrr
      state.status = Status.Failed
      state.utilisateur = null
    },
    markFenetreAideAsSeen: (state, action) => {
      if (state.utilisateur === null) {
        return state
      }
      const { utilisateur } = state
      utilisateur.markFenetreAideAsSeen(action.payload)
      return {
        ...state,
        utilisateur,
      }
    },
    succeededBienAVendreQuizz: (state) => {
      if (state.utilisateur === null) {
        return state
      }
      const { utilisateur } = state
      utilisateur.markFenetreAideAsSeen(
        FenetresAide.PremierAccesCiblerBienAVendre
      )
      return {
        ...state,
        utilisateur,
      }
    },
  },
})

export const {
  succeeded,
  loading,
  error,
  markFenetreAideAsSeen,
  succeededBienAVendreQuizz,
} = utilisateurSlice.actions

export default utilisateurSlice
